// @flow
import SectionSettings from './SectionSettings';

export default SectionSettings;
